export default __webpack_public_path__ + "img/6a278af6576346ea7e93a65e52bc9552.png";